module.exports = __webpack_public_path__ + "static/media/tdkbelleten.b8423833.jpg";